module.exports = __webpack_public_path__ + "static/media/statistikaamet-logo-en.2c7b5f22.svg";